import { IconButton } from '@mui/material';
import { VyIcon } from '@vy/ui-design-system';
import { isNotEmptyString } from '@vy/utils';
import { VyDialog } from '../../../../../../components/new-design/feedback/VyDialog';
import { useDialog } from '../../../../../../hooks/use-dialog';

type DeleteReportButtonProps = {
  onDelete: () => void;
  reportName?: string;
};

export const DeleteReportButton: React.FC<DeleteReportButtonProps> = ({ onDelete, reportName }) => {
  const { isDialogOpen, handleOpen, handleClose } = useDialog();

  return (
    <>
      <IconButton
        onClick={handleOpen}
        className="fill-icon opacity-0 transition-opacity duration-75 group-hover:opacity-100"
      >
        <VyIcon icon="Delete" />
      </IconButton>

      <VyDialog
        open={isDialogOpen}
        onClose={handleClose}
        label={`Delete ${isNotEmptyString(reportName) ? reportName : 'report'}`}
        labelDescription="Are you sure you want to delete this report?"
        ctaText="Delete report"
        warningText="This action is final and cannot be reversed"
        cancelButtonText="Cancel"
        onSubmit={onDelete}
      />
    </>
  );
};
